// src/sot/primitives/FullBleedDivider.jsx
import React from "react";

/**
 * FullBleedDivider
 * Rail-bounded full-bleed divider.
 * Breaks out of AfriMed rail padding, but stays inside the rail width.
 */
export default function FullBleedDivider({ className = "" }) {
  return (
    <div
      className={`rail-bleed h-px w-auto bg-[var(--Schemes-Outline-Variant,#E6E7EB)] ${className}`}
    />
  );
}
